import './LeftMenuDesign.scss';
import { CSSTransition } from 'react-transition-group';
import { Divider } from 'antd';
import { useRef } from 'react';
import { Drawer } from 'antd';
import { cn } from '../../../utils/string/cn.utils';

const LeftMenuDesign = ({ open, header, content, classNames, styles }) => {
  const containerRef = useRef(null);

  return (
    <div
      ref={containerRef}
      // style={{ position: 'relative' }}
      className={cn('[&_.ant-drawer]:absolute z-0', classNames?.root)}
    >
      <Drawer
        title={header}
        placement="left"
        closable={false}
        onClose={() => {}}
        open={open}
        width={280}
        classNames={{
          body: cn('!p-0 flex flex-col bg-[#F7F7F7]', classNames?.body),
          header: cn(
            '[&_.ant-drawer-title]:flex [&_.ant-drawer-title]:items-center [&_.ant-drawer-title]:justify-between bg-fills-white',
            classNames?.header
          ),
          wrapper: cn('rounded-[8px] !duration-400', classNames?.wrapper),
          content: cn('rounded-[8px]', classNames?.content),
          mask: cn('bg-transparent rounded-[8px]', classNames?.mask),
        }}
        getContainer={() => containerRef.current}
      >
        {content}
      </Drawer>
    </div>
  );
};

export default LeftMenuDesign;
